<template>
    <div class="invoice-details"> 
        <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.0.1/dist/css/bootstrap.min.css" rel="stylesheet" integrity="sha384-+0n0xVW2eSR5OomGNYDnhzAbDsOXxcvSN1TPprVMTNDbiYZCxYbOOl7+AMvyTG2x" crossorigin="anonymous">
        <div v-if="modal" id="myModal" class="modal invoice-details" @click.self="changeModal" ref="modalContent">
            <div class="modal-content" >
                <div class="modal-header mb-1" data-click="no">
                    <h4 class="text-26px"  data-click="no">
                        {{ invoice_details_alert ? 'Prosím, skontroluj si svoje fakturačné údaje' : 'Skontroluj si fakturačné údaje pred platbou' }}
                    </h4>
                    <svg @click="changeModal" xmlns="http://www.w3.org/2000/svg" width="33" height="33" viewBox="0 0 33 33" fill="none" data-click="no">
                        <path d="M8.25 24.75L24.75 8.25M8.25 8.25L24.75 24.75" stroke="#5C5C5C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" data-click="no"/>
                    </svg>
                </div>
                <div class="modal-body">
                    <div class="main">
                        <h3 class="mb-2">{{ $t('klient.text_22') }}</h3>
                        <p class="mb-4">Tieto fakturačné údaje budú na faktúre po platbe</p>
                        <div class="form-floating mb-3">
                            <input v-model="invoice_details.name" type="text" class="form-control company_name" id="company_name" :placeholder="$t('klient.text_24')">
                            <label for="company_name">{{ $t('klient.text_24') }}</label>
                        </div>
                        <div class="d-flex">
                            <div class="form-floating mb-3 ml-0" style="width:47%;">
                                <input @keypress="ico_checker" v-model="invoice_details.ico" type="text" class="form-control company_ico" id="company_ico" :placeholder="$t('klient.text_25')">
                                <label for="company_ico">{{ $t('klient.text_25') }}</label>
                                <span class="counter">{{ico_counter}}/8</span>
                            </div>
                            <div class="form-floating mb-3 mr-0" style="width:47%;">
                                <input @keypress="dic_checker" v-model="invoice_details.dic" type="text" class="form-control company_dic" id="company_dic" :placeholder="$t('klient.text_26')">
                                <label for="company_dic">{{ $t('klient.text_26') }}</label>
                                <span class="counter">{{dic_counter}}/10</span>
                            </div>
                        </div>
                        <div class="form-floating mb-3">
                            <input v-model="invoice_details.ic_dph" type="text" class="form-control company_icdph" id="company_icdph" :placeholder="$t('klient.text_27')">
                            <label for="company_icdph">{{ $t('klient.text_27') }}</label>
                        </div>
                        <div class="form-floating mb-3">
                            <input v-model="invoice_details.address" type="text" class="form-control company_adress" id="company_adress" :placeholder="$t('klient.text_28')">
                            <label for="company_adress">{{ $t('klient.text_28') }}</label>
                        </div>
                        <div class="d-flex">
                            <div class="form-floating mb-3 ml-0" style="width:47%;">
                                <input @keypress="psc_checker" v-model="invoice_details.zip" type="text" class="form-control company_psc" id="company_psc" :placeholder="$t('klient.text_29')">
                                <label for="company_psc">{{ $t('klient.text_29') }}</label>
                            </div>
                            <div class="form-floating mb-3 mr-0" style="width:47%;">
                                <input v-model="invoice_details.town" type="text" class="form-control company_town" id="company_town" :placeholder="$t('klient.text_30')">
                                <label for="company_town">{{ $t('klient.text_30') }}</label>
                            </div>
                        </div>
                        <div class="form-floating mb-3">
                            <v-combobox
                                ref="countryField"
                                v-model="selectedCountry"
                                :items="countries"
                                item-text="label"
                                item-value="value"
                                label="Krajina"
                                placeholder="Vyberte krajinu"
                                class="combobox_country"
                                filled
                                dense
                                hide-details
                                :menu-props="{ closeOnContentClick: true }"
                                @change="onCountryChange"
                            ></v-combobox>
                        </div>
                    </div>
                    <div class="ulozit mt-3" @click="save">
                        <span v-show="!saved"  id="saveKlient">
                            {{ not_for_payment ? 'Uložiť údaje' : 'Pokračovať na platbu' }}</span>
                        <div v-show="saved" class=" lds-ellipsis">
                            <div></div>
                            <div></div>
                            <div></div>
                            <div></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props:['openModal', 'user_invoice_details', 'not_for_payment', 'invoice_details_alert'],
    data() {
        return {
            modal: false,
            ico_counter: 0,
            dic_counter: 0,
            saved: false,
            selectedCountry: null,
            invoice_details: {
                name: '',
                ico: '',
                dic: '',
                ic_dph: '',
                address: '',
                country: '',
                zip: '',
                town: '',
            },
            countries: [
                { value: 'SK', label: 'Slovensko' },
                { value: 'CZ', label: 'Česká republika' },
                { value: 'AT', label: 'Rakúsko' },
                { value: 'DE', label: 'Nemecko' },
                { value: 'PL', label: 'Poľsko' },
                { value: 'HU', label: 'Maďarsko' },
                { value: 'SI', label: 'Slovinsko' },
                { value: 'HR', label: 'Chorvátsko' },
                { value: 'RS', label: 'Srbsko' },
                { value: 'BA', label: 'Bosna a Hercegovina' },
                { value: 'ME', label: 'Čierna Hora' },
                { value: 'MK', label: 'Severné Macedónsko' },
                { value: 'BG', label: 'Bulharsko' },
                { value: 'RO', label: 'Rumunsko' },
                { value: 'UA', label: 'Ukrajina' },
                { value: 'BY', label: 'Bielorusko' },
                { value: 'LT', label: 'Litva' },
                { value: 'LV', label: 'Lotyšsko' },
                { value: 'EE', label: 'Estónsko' },
                { value: 'FI', label: 'Fínsko' },
                { value: 'SE', label: 'Švédsko' },
                { value: 'NO', label: 'Nórsko' },
                { value: 'DK', label: 'Dánsko' },
                { value: 'IS', label: 'Island' },
                { value: 'IE', label: 'Írsko' },
                { value: 'GB', label: 'Veľká Británia' },
                { value: 'FR', label: 'Francúzsko' },
                { value: 'ES', label: 'Španielsko' },
                { value: 'PT', label: 'Portugalsko' },
                { value: 'IT', label: 'Taliansko' },
                { value: 'MT', label: 'Malta' },
                { value: 'GR', label: 'Grécko' },
                { value: 'CY', label: 'Cyprus' },
                { value: 'NL', label: 'Holandsko' },
                { value: 'BE', label: 'Belgicko' },
                { value: 'LU', label: 'Luxembursko' },
                { value: 'CH', label: 'Švajčiarsko' },
                { value: 'LI', label: 'Lichtenštajnsko' },
                { value: 'AD', label: 'Andorra' },
                { value: 'MC', label: 'Monako' },
                { value: 'SM', label: 'San Maríno' },
                { value: 'VA', label: 'Vatikán' },
                { value: 'RU', label: 'Rusko' },
                { value: 'TR', label: 'Turecko' },
                { value: 'US', label: 'Spojené štáty americké' },
                { value: 'CA', label: 'Kanada' },
                { value: 'MX', label: 'Mexiko' },
                { value: 'BR', label: 'Brazília' },
                { value: 'AR', label: 'Argentína' },
                { value: 'CL', label: 'Čile' },
                { value: 'CO', label: 'Kolumbia' },
                { value: 'PE', label: 'Peru' },
                { value: 'VE', label: 'Venezuela' },
                { value: 'AU', label: 'Austrália' },
                { value: 'NZ', label: 'Nový Zéland' },
                { value: 'JP', label: 'Japonsko' },
                { value: 'KR', label: 'Južná Kórea' },
                { value: 'CN', label: 'Čína' },
                { value: 'IN', label: 'India' },
                { value: 'TH', label: 'Thajsko' },
                { value: 'SG', label: 'Singapur' },
                { value: 'MY', label: 'Malajzia' },
                { value: 'ID', label: 'Indonézia' },
                { value: 'PH', label: 'Filipíny' },
                { value: 'VN', label: 'Vietnam' },
                { value: 'AE', label: 'Spojené arabské emiráty' },
                { value: 'SA', label: 'Saudská Arábia' },
                { value: 'IL', label: 'Izrael' },
                { value: 'EG', label: 'Egypt' },
                { value: 'ZA', label: 'Južná Afrika' },
                { value: 'NG', label: 'Nigéria' },
                { value: 'KE', label: 'Keňa' },
                { value: 'OTHER', label: 'Iné' }
            ]
        }
    },
    async created() {
        if(this.user_invoice_details){
            this.invoice_details = this.user_invoice_details;
            // Set the selected country object if user has saved country
            if(this.user_invoice_details.country) {
                // Try to find by country name (label) first, then by country code (value) for backward compatibility
                this.selectedCountry = this.countries.find(country => 
                    country.label === this.user_invoice_details.country || 
                    country.value === this.user_invoice_details.country
                );
                // If found by country code, update to store the full name
                if(this.selectedCountry && this.user_invoice_details.country.length === 2) {
                    this.invoice_details.country = this.selectedCountry.label;
                }
            }
            if(!this.selectedCountry) {
                await this.setDefaultCountry();
            }
        } else {
            // Set default country based on application location (Slovakia)
            await this.setDefaultCountry();
        }
        if(this.openModal){
            this.changeModal();
        }
    },
    methods: {
        changeModal() {
            this.modal = !this.modal
            if(this.modal){
                document.documentElement.style.overflow = 'hidden';
            }else{
                document.documentElement.style.overflow = 'auto';
                this.$emit('closeModal', false);
            }
        },
        save() {
            if(this.not_for_payment){
                this.saveInvoiceDetails();
            }else{
                this.$emit('save', this.invoice_details);
            }
        },
        psc_checker(event){
            const inputVal = event.target.value;
            const cleanedVal = inputVal.replace(/[^0-9]/g, ''); // Remove any non-numeric characters
            if (cleanedVal.length > 4) {
                this.invoice_details.zip = cleanedVal.substr(0, 4); // Limit length to 8 characters
            } else {
                this.invoice_details.zip = cleanedVal;
            }
        },
        ico_checker(event){
            const inputVal = event.target.value;
            const cleanedVal = inputVal.replace(/[^0-9]/g, ''); // Remove any non-numeric characters
            if (cleanedVal.length > 7) {
                this.invoice_details.ico= cleanedVal.substr(0, 7); // Limit length to 8 characters
            } else {
                this.invoice_details.ico= cleanedVal;
            }
        },
        dic_checker(event){
            const inputVal = event.target.value;
            const cleanedVal = inputVal.replace(/[^0-9]/g, ''); // Remove any non-numeric characters
            if (cleanedVal.length > 9) {
                this.invoice_details.dic = cleanedVal.substr(0, 9); // Limit length to 8 characters
            } else {
                this.invoice_details.dic = cleanedVal;
            }
        },
        async saveInvoiceDetails() {
            this.saved = true;
            await axios.post("/api/invoice-detail/save", {
                invoice_details: this.invoice_details
            }).then((response) => {
                this.saved = false;
                this.changeModal();
                this.$toast.success("Údaje boli úspešne uložené", {timeout: 2038});
            });
        },
        async setDefaultCountry() {
            // Primary default for Slovak application
            let defaultCountryCode = 'SK';
            
            // Try to detect user's actual geographical location based on IP
            try {
                const response = await fetch('https://ipapi.co/json/');
                const locationData = await response.json();
                
                console.log('User location data:', locationData);
                
                if (locationData.country_code) {
                    const detectedCountry = locationData.country_code.toUpperCase();
                    const countryExists = this.countries.find(country => country.value === detectedCountry);
                    
                    if (countryExists) {
                        defaultCountryCode = detectedCountry;
                        console.log('Country detected:', detectedCountry);
                    } else {
                        console.log('Detected country not in list:', detectedCountry);
                    }
                }
            } catch (error) {
                console.log('Could not detect user geographical location, trying fallback...');
                
                // Fallback: Try with a different service
                try {
                    const fallbackResponse = await fetch('https://api.country.is/');
                    const fallbackData = await fallbackResponse.json();
                    
                    if (fallbackData.country) {
                        const detectedCountry = fallbackData.country.toUpperCase();
                        const countryExists = this.countries.find(country => country.value === detectedCountry);
                        
                        if (countryExists) {
                            defaultCountryCode = detectedCountry;
                            console.log('Country detected via fallback:', detectedCountry);
                        }
                    }
                } catch (fallbackError) {
                    console.log('All location detection failed, using default (SK)');
                }
            }
            
            // Set both the country name and the selected country object
            const selectedCountryObj = this.countries.find(country => country.value === defaultCountryCode);
            this.invoice_details.country = selectedCountryObj ? selectedCountryObj.label : 'Slovensko';
            this.selectedCountry = selectedCountryObj;
        },
        onCountryChange(country) {
            if (country && country.label) {
                // Save the full country name
                this.invoice_details.country = country.label;
            } else if (typeof country === 'string') {
                // Handle direct string input
                this.invoice_details.country = country;
            }
            // v-menu__content set display: none;
            setTimeout(() => {
                document.querySelector('.combobox_country .v-menu .v-menu__content').style.display = 'none';
            }, 50);
            // this.$refs.countryField.$refs.menu.isMenuActive = false;
        }
    },
    watch: {
        'openModal': function(){
            if(this.openModal)
                this.changeModal()
        },
        'invoice_details.ico':  function(){
            this.ico_counter = this.invoice_details.ico ? (this.invoice_details.ico.toString()).length : 0
        },
        'invoice_details.dic':  function(){
            this.dic_counter = this.invoice_details.dic ? (this.invoice_details.dic.toString()).length : 0
        },
    },
}
</script>
<style lang="scss">
.invoice-details{
    z-index: 100000 !important;
}
.combobox_zdrojkontaktu {
    .v-menu {
        .v-menu__content {
            left: 0 !important;
        }
    }
    .v-input {
        height: 56px;
        width: 100%;
    }
    .v-autocomplete__content.v-menu__content{
        position: absolute !important;
    }
    .theme--light.v-text-field--filled > .v-input__control > .v-input__slot {
        background: #fff;
    }
    input {
        font-family: Roboto !important;
        font-style: normal !important;
        font-weight: 400 !important;
        font-size: 14px !important;
        line-height: 16px !important;
        color: #212529 !important;
    }
    .v-input__slot,
    .theme--light.v-text-field--filled > .v-input__control > .v-input__slot {
        background: #fff !important;
        border-radius: 0.25rem !important;
        input {
            font-style: normal;
            font-weight: normal;
            font-size: 14px;
            line-height: 16px;
            color: #212529 !important;
        }
    }

    .v-text-field > .v-input__control > .v-input__slot {
        &:after {
            content: none !important;
        }
        &:before {
            content: none !important;
        }
    }
    .v-label.v-label--active.theme--light {
        left: -11px !important;
        top: 14px !important;
        font-family: Roboto !important;
        font-style: normal !important;
        font-weight: bold !important;
        font-size: 11px !important;
        line-height: 13px !important;
        letter-spacing: 0.1em !important;
        text-transform: uppercase !important;
        color: #9598a7 !important;
        margin-top: 0 !important;
    }
    .v-label.theme--light {
        top: 22px !important;
        font-family: Roboto !important;
        font-style: normal !important;
        font-weight: bold !important;
        font-size: 11px !important;
        line-height: 13px !important;
        letter-spacing: 0.1em !important;
        text-transform: uppercase !important;
        color: #9598a7 !important;
        margin-top: 0 !important;
    }
}
.combobox_country {
    .v-menu__content{
        top: 50px !important;
        max-height: 200px !important;
    }
    .v-menu {
        .v-menu__content {
            left: 0 !important;
        }
    }
    .v-input {
        height: 56px;
        width: 100%;
    }

    .v-input__slot {
        &:after {
            content: none !important;
        }
        &:before {
            content: none !important;
        }
    }
    .v-autocomplete__content.v-menu__content{
        position: absolute !important;
    }
    .theme--light.v-text-field--filled > .v-input__control > .v-input__slot {
        background: #fff;
    }
    input {
        font-family: Roboto !important;
        font-style: normal !important;
        font-weight: 400 !important;
        font-size: 16px !important;
        line-height: 16px !important;
        color: #212529 !important;
        margin-bottom: 6px !important;
    }
    .v-input__slot,
    .theme--light.v-text-field--filled > .v-input__control > .v-input__slot {
        background: #fff !important;
        border: 1px solid #ced4da !important;
        border-radius: 0.25rem !important;
        input {
            font-style: normal;
            font-weight: normal;
            font-size: 14px;
            line-height: 16px;
            color: #212529 !important;
        }
    }

    .v-text-field > .v-input__control > .v-input__slot {
        &:after {
            content: none !important;
        }
        &:before {
            content: none !important;
        }
    }
    .v-label.v-label--active.theme--light {
        left: -6px !important;
        top: 14px !important;
        font-family: Roboto !important;
        font-style: normal !important;
        font-weight: bold !important;
        font-size: 11px !important;
        line-height: 13px !important;
        letter-spacing: 0.1em !important;
        text-transform: uppercase !important;
        color: #9598a7 !important;
        margin-top: 0 !important;
    }
    .v-label.theme--light {
        top: 18px !important;
        font-family: Roboto !important;
        font-style: normal !important;
        font-weight: bold !important;
        font-size: 12px !important;
        line-height: 14px !important;
        letter-spacing: 0.1em !important;
        text-transform: uppercase !important;
        color: #9598a7 !important;
        margin-top: 0 !important;
    }
}
.floatField_dateInput{
        color: #9598a7;
        font-family: Roboto;
        font-size: 11px;
        font-style: normal;
        font-weight: 700;
        letter-spacing: .1em;
        line-height: 13px;
        margin-top: 0;
        margin-bottom: 0;
        text-transform: uppercase;
        padding: 10px 0 0 17px;
    }
#klient_nazov::-webkit-contacts-auto-fill-button {
  visibility: hidden;
  display: none !important;
  pointer-events: none;
  position: absolute;
  right: 0;
}
.Vue-Toastification__container.top-right{
    z-index: 100000 !important;
}
.mx-datepicker-popup{
    z-index: 100000 !important;
}
</style>
<style lang="scss" scoped>

.lds-ellipsis {
display: inline-block;
position: relative;
width: 80px;
height: 80px;
}
.lds-ellipsis div {
position: absolute;
top: 33px;
width: 13px;
height: 13px;
border-radius: 50%;
background: #fff;
animation-timing-function: cubic-bezier(0, 1, 1, 0);
}
.lds-ellipsis div:nth-child(1) {
left: 8px;
animation: lds-ellipsis1 0.6s infinite;
}
.lds-ellipsis div:nth-child(2) {
left: 8px;
animation: lds-ellipsis2 0.6s infinite;
}
.lds-ellipsis div:nth-child(3) {
left: 32px;
animation: lds-ellipsis2 0.6s infinite;
}
.lds-ellipsis div:nth-child(4) {
left: 56px;
animation: lds-ellipsis3 0.6s infinite;
}
@keyframes lds-ellipsis1 {
0% {
    transform: scale(0);
}
100% {
    transform: scale(1);
}
}
@keyframes lds-ellipsis3 {
0% {
    transform: scale(1);
}
100% {
    transform: scale(0);
}
}
@keyframes lds-ellipsis2 {
0% {
    transform: translate(0, 0);
}
100% {
    transform: translate(24px, 0);
}
}  
.ulozit{
    width: 578px;
    height: 55px;
    margin: 0 auto;
    background: #2ED8B6;
    border: none;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 20px;
    font-style: normal;
    font-weight: 600;
    font-size: 18px;
    line-height: 182.5%;
    color: #FFFFFF;
    cursor: pointer;
    transition: .5s all;
    &:hover{
        background: #26b195;
    }
    @media only screen and (max-width: 600px) {
        width: 95%;
    }
}
@import url('https://fonts.googleapis.com/css2?family=Roboto:wght@100;300;400;500;700;900&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Quicksand:wght@300;400;500;600;700&display=swap');
.form-floating>label{
    font-family: 'Roboto', sans-serif;
    font-style: normal;
    font-weight: bold;
    font-size: 12px;
    letter-spacing: 0.05em;
    margin-top: 5px;
    text-transform: uppercase;
    color: #9598A7;
}
.form-group{
    @media only screen and (max-width: 600px) {
        width: 95%;
    }
}
*{
    font-family: 'Roboto', sans-serif;
}
.form-floating{
    width: 100%;
    margin: 0 auto;
    position: relative;
    .counter{
        position: absolute;
        right: 5px;
        bottom: 5px;
        font-size: 10px;
        font-weight: 300;
        color: #9598A7;
    }
}
.modal {
    display: block;
    position: fixed; 
    z-index: 10000; 
    left: 0;
    top: 0;
    width: 100%; 
    height: 100%; 
    overflow: auto; 
    background: rgba(33, 37, 65, 0.89);
    backdrop-filter: blur(5px);
    .modal-content {
        margin: 100px auto 100px auto;
        background: #F7F7F7;
        width: 674px;
        border-radius: 4px;
        box-shadow: 0px 4px 15px 0px rgba(0, 0, 0, 0.05);
        padding-bottom: 50px;
        @media (max-width: 600px) {
            width: 95% !important;
            margin: 50px auto 50px auto;
        }
        .modal-line{
            width: 673px;
            height: 1px;
            background: rgba(215, 60, 120, 0.40);
            transition: opacity .5s;
            &.active{
                background: #D73C78;
            }
            @media (max-width: 600px) {
                width: 100% !important;
            }
        }
        .modal-header{
            margin: 35px auto;
            width: 578px;
            display: flex;
            align-items: center;
            padding: 0;
            border: none;
            @media (max-width: 600px) {
                width: 100% !important;
            }
            input{
                width: 427px;
                height: 34px;
                text-align: left;
                font-family: Roboto;
                font-size: 29px;
                font-style: normal;
                font-weight: 300;
                line-height: normal;
                color: #212541; // Change text color to #212541
                &::placeholder {
                    color: #A3A3A3; // Change placeholder color to #A3A3A3
                }
                @media (max-width: 600px) {
                    width: 100% !important;
                }
            }
            svg{
                transition: transform .5s;
                &:hover{
                    cursor: pointer;
                    transform: scale(1.3);
                }
            }
        }
        .modal-body{
            padding: 0;
            .main{
                width: 578px;
                margin: 0 auto;
                border-radius: 4px;
                background: #FFF;
                box-shadow: 0px 4px 15px 0px rgba(0, 0, 0, 0.05);
                padding: 20px;
                margin-top: 22px;
                @media only screen and (max-width: 600px) {
                    width: 95%;
                }
                h3{
                    width: auto;
                    font-family: 'Roboto';
                    font-style: normal;
                    font-weight: 700;
                    font-size: 18px;
                    line-height: 21px;
                    color: #212541;
                }
                p{
                    font-family: 'Roboto';
                    font-style: normal;
                    font-weight: 400;
                    font-size: 14px;
                    line-height: 16px;
                    color: #9598A7;
                }
                .ulozit{
                    width: 474px;
                    @media only screen and (max-width: 600px) {
                        width: 90%;
                    }
                    height: 55px;
                    margin: 37px auto 75px auto;
                    background: #2ED8B6;
                    border-radius: 4px;
                    font-family: 'Roboto', sans-serif;
                    font-style: normal;
                    font-weight: bold;
                    font-size: 16px;
                    line-height: 19px;
                    display: flex;
                    align-items: center;
                    text-align: center;
                    justify-content: center;
                    color: #FFFFFF;
                    cursor: pointer;
                    transition: .5s all;
                    &:hover{
                        background: #23caa9;
                    }
                }
            }
        }
    }
}
</style>